export enum ROUTER_LINKS {
    DASHBOARD = 'dashboard',
    SWAP = 'swap',
    LOTTERIES = 'lotteries',
    GOVERNANCE = 'governance',
    SOCIAL = 'social',
    FAQ = 'faq',
}
